import React, {useState,useEffect} from 'react';
import './TeamPresentation.scss';
import PersonalFeedback from '../PersonalFeedback/PersonalFeedback';
import PeerFeedback from '../PeerFeedback/PeerFeedback';
import Scroll from '../../../partials/Scroll/Scroll'
import Button from '../../../partials/Button';
import StyledContainer from '../../../partials/StyledContainer';
import Participant from '../../../partials/Participant/Participant';

const TeamPresentation = props => {
    console.log(props);
    
    const jsonIsValid = Object.entries(props.data.scripts).every(([scriptId, script]) => {
        return Object.entries(script.presentationSlides).every(([slideId, slide]) => {
            const isValid = slide.options.every(option => option.followUpQuestion) || slide.next
            if(!isValid) {console.log('script', scriptId, 'slide', slideId, 'is invalid')} 
            return isValid
        })
    });
    
    if (!jsonIsValid) {
        throw new Error('Every script must have either a next property on the slide or a followUpQuestion property on every option')
    }

    function getButtonText() {
        if ((currentSlideId === Object.keys(props.presentationSlides)[0]) && (!currentSlide.speakerKey || (currentSlide.speakerKey === currentSlide.person))) {
            return "START"
        }
        if ((!currentSlide.speakerKey || (currentSlide.speakerKey === currentSlide.person)) && !currentSlide.question) {
            return "CONTINUE"
        }
        return "RESPOND"
    }

    const [selectedOption, setSelectedOption] = useState();
    const [currentSlideId, setCurrentSlideId] = useState(Object.keys(props.presentationSlides)[0]);
    const [currentSlide, setCurrentSlide] = useState(props.presentationSlides[currentSlideId]);
    const [followUpMinimized, setFollowUpMinimized] = useState(false);
    // const [convoPoints, setConvoPoints] = useState(0);

    useEffect(() => setCurrentSlide(props.presentationSlides[currentSlideId]), 
        [currentSlideId, props.presentationSlides])

    // useEffect(() => {props.setConvoPoints(props.convoPoints + (selectedOption?.points || 0))}, [selectedOption])

    useEffect(() => {
        const jsonIsValid = Object.entries(props.data.scripts).every(([scriptId, script]) => {
            return Object.entries(script.presentationSlides).every(([slideId, slide]) => {
                const isValid = slide.options.every(option => option.followUpQuestion) || slide.next
                if(!isValid) {console.log('script', scriptId, 'slide', slideId, 'is invalid')} 
                return isValid
            })
        })
        
        if (!jsonIsValid) {throw new Error('Every script must have either a next property on the slide or a followUpQuestion property on every option')};
    }, [props.data])

    const onNextButtonClicked = () => {
        props.setOptionsTranscript([
            ...props.optionsTranscript, {slideId:currentSlideId, option:selectedOption}
        ])
        console.log('selected option', selectedOption, 'current slide', currentSlide);
        setCurrentSlideId(selectedOption?.followUpQuestion || currentSlide.next)
        setSelectedOption()
        setFollowUpMinimized(false)
    }

    const onRetryButtonClicked = () => {
        setSelectedOption()
    }

    const onRespondButtonClick = () => setFollowUpMinimized(!followUpMinimized);
    const personalFeedbackScreen = currentSlide?.question && !selectedOption;

    return (
        
            <>
                <div className='left-container'>
                {
                    personalFeedbackScreen && !followUpMinimized 
                    ? 
                        <div className='expanded-question'>
                            <div className='content-container'>
                                <StyledContainer variant='light_blue'>
                                    <div className='feedback' 
                                    dangerouslySetInnerHTML={{ __html: currentSlide.question}} />
                                </StyledContainer>
                            </div>
                            <div className='respond-button-container'>
                                <Button 
                                    className="respond-btn" 
                                    onClick={onRespondButtonClick} 
                                    alt="Respond" 
                                    text={getButtonText()} />
                                    {/* text="RESPOND" /> */}
                            </div>
                        </div>
                    :
                        <div>
                            {/* Change name by accessing first name of character from the JSON */}
                            <h2 className={`prompt`}>{currentSlide.prompt || ''}</h2>
                            {/* Here we map through a list of options for the user to display */}
                            <Scroll>
                                {currentSlide.options.map((option, i) => {
                                    return <div 
                                        key={`${option.slideKey} o-${i}`}
                                        className={`option ${selectedOption === option ? 'selected' : ''}`} 
                                        dangerouslySetInnerHTML={{ __html: option.option}}
                                        onClick={() => {
                                            if (!selectedOption) {
                                                setSelectedOption(option)
                                            }}}
                                    >
                                    </div>
                                })}
                            </Scroll>
                        </div>

                }

                    
                </div>

                                {/* <img src='media/img/team-meeting/default-presentation-img.png' /> */}
                <div className='center-container'>
                    <div className='presentation-display'>
                        {/* Here we render the image(s) to display on the whiteboard */}
                        {selectedOption 
                            ?
                                selectedOption.img && <img src={selectedOption.img} />
                            :
                                <></>
                        }
                    </div>
                    <div className='team-feedback'>
                        {/* Here we will display either the reactions from other teams, a sub-team lead posing a question, or nothing depending on where we are in the presentation */}
                        {/* If we are showing reactions from other teams, we will also need a <p> element to display feedback of the learner's choice below */}
                        {personalFeedbackScreen && <PersonalFeedback 
                            teamMember={currentSlide.speakerKey === currentSlide.person ? null : props.people[currentSlide.speakerKey]} 
                            speakerView={followUpMinimized ? 'minimized-question' : 'flying-question'}
                        >
                            {followUpMinimized && 
                                <StyledContainer variant='light_blue' className='feedback'>
                                    <div className='feedback-text' dangerouslySetInnerHTML={{ __html: currentSlide.question}}></div>
                                    <div className="feedback-button-row">

                                    </div>
                                </StyledContainer>
                            }
                        </PersonalFeedback>
                        }

                        {selectedOption && <PeerFeedback 
                            people={props.people} 
                            selectedOption={selectedOption} 
                        />}
                        <p>{selectedOption && selectedOption.feedback.content}</p>
                    </div>
                </div>

                <div className='right-container'>

                    <div className='tmc-container'>
                        {/* <p className='points-tally'>convo points: <span className="points">{props.convoPoints}</span>/35</p> */}
                        <Participant
                            data={props.data}
                            hasNameTag={true}
                            isYou={true}
                            teamMember={props.teamMember}
                            hasVisited={false}
                            showDialog={false}
                        />
                    </div>
                
                    <div className={selectedOption ? '' : 'hidden-button'}>
                        <Button text="Next"  onClick={currentSlide.next === 'conclusion' ? props.onConclusion : onNextButtonClicked} size='small' ></Button>
                        <Button text="Retry"  onClick={onRetryButtonClicked} size='small' ></Button>
                    </div>
                        
                        
                </div>
            </>    
        
    )
}

export default TeamPresentation;